import { apiClient } from './client';
import type { ApiResponse } from './types';
import type {
  AvailableRewardsResponse,
  ClaimRewardRequest,
  ClaimRewardResponse,
  UserReward,
} from './rewardTypes';

export const rewardService = {
  // Check reward eligibility after payment
  async checkEligibility(
    paymentId: string
  ): Promise<ApiResponse<AvailableRewardsResponse>> {
    return apiClient.get<ApiResponse<AvailableRewardsResponse>>(
      `/rewards/check-eligibility/${paymentId}`
    );
  },

  // Claim rewards (select coupons)
  async claimRewards(
    data: ClaimRewardRequest
  ): Promise<ApiResponse<ClaimRewardResponse>> {
    return apiClient.post<ApiResponse<ClaimRewardResponse>>(
      '/rewards/claim',
      data
    );
  },

  // Get user's reward history
  async getRewardHistory(): Promise<ApiResponse<UserReward[]>> {
    return apiClient.get<ApiResponse<UserReward[]>>('/rewards/history');
  },

  // Get a single reward by ID
  async getRewardById(id: string): Promise<ApiResponse<UserReward>> {
    return apiClient.get<ApiResponse<UserReward>>(`/rewards/${id}`);
  },

  // Mark reward as used
  async markRewardAsUsed(id: string): Promise<ApiResponse<UserReward>> {
    return apiClient.patch<ApiResponse<UserReward>>(
      `/rewards/my-rewards/${id}/use`
    );
  },
};
